/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Referral_Access_CurrentInputs */

const en_plan_referral_access_current = /** @type {(inputs: Plan_Referral_Access_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your access is currently covered by a referral reward.`)
};

const es_plan_referral_access_current = /** @type {(inputs: Plan_Referral_Access_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu acceso está cubierto actualmente por una recompensa de referido.`)
};

/**
* | output |
* | --- |
* | "Your access is currently covered by a referral reward." |
*
* @param {Plan_Referral_Access_CurrentInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_referral_access_current = /** @type {((inputs?: Plan_Referral_Access_CurrentInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Referral_Access_CurrentInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_referral_access_current(inputs)
	return en_plan_referral_access_current(inputs)
});